const subscriptionStates = [
  {
    class: '',
    id: '',
    name: 'Todos los estados'
  },

  {
    class: 'text-color-warning',
    // Recien creada, no se notificó al Gw todavía
    id: 0,
    name: 'Notificar'
  },

  {
    class: 'text-color-warning',
    // Se creo, pero todavía no está confirmada
    id: 1,
    name: 'Notificada'
  },

  {
    class: 'text-color-danger',
    // Se produjo un error al crear la suscripcion en la plataforma de pago, reintentar
    id: 2,
    name: 'Fallo'
  },

  {
    class: 'text-color-success',
    // Esta Activa
    id: 3,
    name: 'Activa'
  },

  {
    class: 'text-color-warning',
    // Esta Suspendida
    id: 4,
    name: 'Suspendida'
  },

  {
    class: 'text-color-info',
    // Se concluyó exitosamente (Ej: Cuotas fintas pagadas)
    id: 5,
    name: 'Finalizada'
  },

  {
    class: 'text-color-info',
    // Se reemplazo por una suscripcion diferente
    id: 6,
    name: 'Reemplazada'
  },

  {
    class: 'text-color-danger',
    // Se canceló (por el usuario o el administrador)
    id: 7,
    name: 'Cancelada'
  }
]

export default subscriptionStates
